import { render, staticRenderFns } from "./BasePureTable.vue?vue&type=template&id=3fdf3788&scoped=true&"
import script from "./BasePureTable.vue?vue&type=script&lang=js&"
export * from "./BasePureTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/TableStyle.module.css?vue&type=style&index=0&id=3fdf3788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf3788",
  null
  
)

export default component.exports